import { useSelector } from 'react-redux';
import { ApplicationState } from '../../rootStore';
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from '@/main/services/reducerUtils';
import { ManufacturerState } from './manufacturerTypes';

export const useManufacturerReducer = (keyReducer: string = 'default') => {
  const returnSelector = useSelector(
    (state: ApplicationState) => state.manufacturer
  );
  if (keyReducer === 'default')
    return returnSelector as IReducerWithIsolated<ManufacturerState>;

  const updateState = {
    ...returnSelector,
    isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA
  };

  return updateState as IReducerWithIsolated<ManufacturerState>;
};

